// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: KM3TUXtSzqd3
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicAddMilestoneModal.module.css"; // plasmic-import: KM3TUXtSzqd3/css

createPlasmicElementProxy;

export const PlasmicAddMilestoneModal__VariantProps = new Array();

export const PlasmicAddMilestoneModal__ArgProps = new Array();

const $$ = {};

function PlasmicAddMilestoneModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames(projectcss.all, sty.header)}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__v3T1
          )}
        >
          {"Add Milestone"}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__x0LFt
          )}
        >
          {"X"}
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___0LFwx)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__ts8Qm
          )}
        >
          {"Milestone Name"}
        </div>
        <input
          data-plasmic-name={"city"}
          data-plasmic-override={overrides.city}
          className={classNames(projectcss.all, projectcss.input, sty.city)}
          placeholder={"Milestone Name"}
          ref={ref => {
            $refs["city"] = ref;
          }}
          size={1}
          type={"text"}
          value={""}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__nz2V9
          )}
        >
          {"Amount"}
        </div>
        <div
          data-plasmic-name={"amount"}
          data-plasmic-override={overrides.amount}
          className={classNames(projectcss.all, sty.amount)}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__bxNjs
          )}
        >
          {"Payment Due Date (optional)"}
        </div>
        <div
          data-plasmic-name={"dueDate"}
          data-plasmic-override={overrides.dueDate}
          className={classNames(projectcss.all, sty.dueDate)}
        />

        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__qlntV
          )}
        >
          {"Description (optional)"}
        </div>
        <textarea
          data-plasmic-name={"contractDescription"}
          data-plasmic-override={overrides.contractDescription}
          className={classNames(
            projectcss.all,
            projectcss.textarea,
            sty.contractDescription
          )}
          ref={ref => {
            $refs["contractDescription"] = ref;
          }}
          value={""}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__g21Sh)}>
        <div className={classNames(projectcss.all, sty.freeBox__vVci0)}>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__wH2Hp
            )}
          >
            {"Submit"}
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "header", "city", "amount", "dueDate", "contractDescription"],
  header: ["header"],
  city: ["city"],
  amount: ["amount"],
  dueDate: ["dueDate"],
  contractDescription: ["contractDescription"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAddMilestoneModal__ArgProps,
          internalVariantPropNames: PlasmicAddMilestoneModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAddMilestoneModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAddMilestoneModal";
  } else {
    func.displayName = `PlasmicAddMilestoneModal.${nodeName}`;
  }
  return func;
}

export const PlasmicAddMilestoneModal = Object.assign(
  // Top-level PlasmicAddMilestoneModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    city: makeNodeComponent("city"),
    amount: makeNodeComponent("amount"),
    dueDate: makeNodeComponent("dueDate"),
    contractDescription: makeNodeComponent("contractDescription"),
    // Metadata about props expected for PlasmicAddMilestoneModal
    internalVariantProps: PlasmicAddMilestoneModal__VariantProps,
    internalArgProps: PlasmicAddMilestoneModal__ArgProps
  }
);

export default PlasmicAddMilestoneModal;
/* prettier-ignore-end */
